/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import GlobalModel from 'echarts/lib/model/Global';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import SeriesModel from 'echarts/lib/model/Series';
import { SeriesMaskConfig, Point } from '../../type';
import WordCloudSeries, { WordCloudBaseLayoutOption } from '../../WordCloudSeries';
import themeRiver from './themeRiver';

// TODO:需要修改wordCloud的layout优先级，以确保他一定是在最后执行的，保证可以在layout中获取到其他series的layout信息
/**
 * 根据依赖的series类型来获取点集
 * TODO: 补充其他系列
 */
const seriesTypeToPointsGetter = {
  themeRiver
};

function getSeriesByMask(mask: SeriesMaskConfig, ecModel: GlobalModel) {
  const { seriesIndex, seriesName } = mask;
  let targetSeries;
  if (typeof seriesIndex === 'number' && !Number.isNaN(seriesIndex)) {
    targetSeries = ecModel.getSeriesByIndex(seriesIndex);
  }

  if (!targetSeries && typeof seriesName === 'string' && seriesName.length) {
    targetSeries = ecModel.getSeriesByName(seriesName);
  }
  return targetSeries as SeriesModel;
}

export default function getPointsFromSeries(
  mask: WordCloudBaseLayoutOption['mask'],
  ecModel: GlobalModel,
  api: ExtensionAPI,
  wordCloudSeries: WordCloudSeries
): Point[] {
  if (!mask || (!('seriesIndex' in mask) && !('seriesName' in mask))) {
    return [];
  }
  const seriesModel = getSeriesByMask(mask, ecModel);
  if (!seriesModel) {
    return [];
  }
  const { subType } = seriesModel;
  const pointsGetter = seriesTypeToPointsGetter[subType];
  if (!pointsGetter) {
    return [];
  }
  return pointsGetter(mask, wordCloudSeries, seriesModel, ecModel, api) as Point[];
}
